import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { useTheme } from 'hooks/useTheme';
interface PreferenceCardProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  iconColor?: string;
  titleColor?: string;
  dividerColor?: string;
  backgroundColor?: string;
  padding?: string | number;
  spacing?: number;
}

const PreferenceCard: React.FC<PreferenceCardProps> = ({
  icon,
  title,
  children,
  iconColor,
  titleColor,
  dividerColor,
  backgroundColor,
  padding = 2,
  spacing = 2,
}) => {
  const theme = useTheme();
  const colors = {
    icon: iconColor || theme.theme.primary,
    title: titleColor || theme.theme.text.primary,
    divider: dividerColor || theme.theme.primary,
    background: backgroundColor || theme.theme.background.secondary,
  };

  return (
    <Box
      sx={{
        backgroundColor: colors.background,
        borderRadius: 2,
        padding: padding,
        minHeight: '140px',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Stack
        display="flex"
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        spacing={0}
        sx={{
          marginBottom: spacing,
        }}
      >
        <Box
          sx={{
            color: colors.icon,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            fontSize: 16,
            width: 20,
            height: 16,
          }}
        >
          {icon}
        </Box>
        <Typography
          variant="h6"
          sx={{
            color: colors.title,
            fontWeight: 'bold',
            fontSize: 16,
            lineHeight: 1.2,
            justifyContent: 'flex-start',
            ml: 0.5,
          }}
        >
          {title}
        </Typography>
      </Stack>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default React.memo(PreferenceCard);
